import React, { useMemo, useState } from 'react';
import { Box, Paper, Tabs, Tab } from '@mui/material';
import HSGroupedHSCodeAnalysis from './HSGroupedHSCodeAnalysis';
import ProdcomGroupedProdcomCodeAnalysis from './ProdcomGroupedProdcomCodeAnalysis';

type TradeCodesTab = 'hs' | 'prodcom';

const STORAGE_TAB_KEY = 'tradeCodes.activeTab';

interface TradeCodesViewProps {
  canAccessProdcom?: boolean;
}

const TradeCodesView: React.FC<TradeCodesViewProps> = ({ canAccessProdcom = true }) => {
  const [activeTab, setActiveTab] = useState<TradeCodesTab>(() => {
    const stored = localStorage.getItem(STORAGE_TAB_KEY);
    if (!canAccessProdcom) {
      return 'hs';
    }
    return stored === 'prodcom' ? 'prodcom' : 'hs';
  });

  const handleChange = (_event: React.SyntheticEvent, next: TradeCodesTab) => {
    if (next === 'prodcom' && !canAccessProdcom) {
      return;
    }
    setActiveTab(next);
    try {
      localStorage.setItem(STORAGE_TAB_KEY, next);
    } catch {}
  };

  const tabSx = useMemo(() => ({
    textTransform: 'none',
    fontWeight: 600,
    minHeight: 48
  }), []);

  const normalizedActiveTab: TradeCodesTab = canAccessProdcom ? activeTab : 'hs';

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Paper elevation={1} sx={{ bgcolor: 'rgba(255,255,255,0.3)', border: '1px solid', borderColor: (t) => t.palette.divider }}>
        <Tabs
          value={normalizedActiveTab}
          onChange={handleChange}
          aria-label="Trade codes view tabs"
          variant="fullWidth"
        >
          <Tab label="HS Codes" value="hs" sx={tabSx} />
          <Tab
            label={canAccessProdcom ? "PRODCOM" : "PRODCOM (No access)"}
            value="prodcom"
            sx={tabSx}
            disabled={!canAccessProdcom}
          />
        </Tabs>
      </Paper>

      {normalizedActiveTab === 'hs' ? <HSGroupedHSCodeAnalysis /> : <ProdcomGroupedProdcomCodeAnalysis />}
    </Box>
  );
};

export default TradeCodesView;
